<template>
  <div
    @mouseenter="hoverEvent"
    @mouseleave="hoverEvent"
    class="submit-button"
    :class="loadingClass"
  >
    <AppButton v-on="$listeners" v-bind="$attrs" primary>
      <Spinner v-if="loading" :size="spinnerSize" :color="spinnerColor" />
      <template v-else>
        <slot />
      </template>
    </AppButton>
  </div>
</template>

<script>
// Components
import Spinner from 'Ui/AppSpinner'
import AppButton from 'Ui/AppButton'

export default {
  name: 'SubmitButton',

  inheritAttrs: false,

  components: {
    AppButton,
    Spinner,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },

    className: {
      type: String,
      default: '',
    },

    spinnerColor: {
      type: String,
      default: 'var(--c-secondary-600)',
    },

    spinnerSize: {
      type: [String, Number],
      default: 25,
    },
  },

  methods: {
    hoverEvent(event) {
      this.$emit('hoverEvent', event)
    },
  },

  computed: {
    loadingClass() {
      return this.loading && 'loading'
    },
  },
}
</script>

<style>
.submit-button {
  width: 152px;
}

.submit-button.disabled {
  cursor: not-allowed;
  pointer-events: all;
}

.submit-button .app-button {
  width: 100%;
}

.submit-button.disabled .app-button,
.submit-button.loading .app-button {
  pointer-events: none;
}

.submit-button.loading .app-button {
  justify-content: center !important;
}
</style>
